import React, { useEffect, useState } from 'react';
import Header from "./Header/Header.js";
import MenuLateral from "./MenuLateral";
import '../assets/styles/components/Layout.scss'
import layout from '../lib/layout.js';

export default function Layout({ children, id = '', className = '', style = {} }) {
  const [open, setOpen] = useState(() => layout.menuOpen ?? true);

  useEffect(() => {
    layout.setMenuOpen(open);
  }, [open]);

  const toggle = () => setOpen(v => !v);

  const isTestEnv =
    /\/qas\./i.test(window.location.href) || /\/localhost[:]/i.test(window.location.href);

  return (
    <div id={id} className={`layout ${className}`} style={style}>
      <MenuLateral open={open} openMenu={setOpen} />
      <div className={`layout-body ${open ? 'menu-open' : ''}`}>
        {isTestEnv ? <div className="test-environment">Atenção: Você está em um ambiente de testes.</div> : ''}
        <Header openMenu={toggle} />
        <main id="container-main">
          {children}
        </main>
      </div>
    </div>
  );
}
